export default __webpack_public_path__ + "static/media/app-store-panel-2.00022b9f.png";